<div class="modal-header">
  <h4 class="modal-title">Provide Estimate</h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="cancel()"
  ></button>
</div>

<form [formGroup]="form" (ngSubmit)="save()">
  <div class="modal-body">
    <div class="order-form row">
      <div class="form-group d-flex align-items-center col-lg-12 mb-3">
        <h5>
          <span>{{ weightKg }}KG </span> X
        </h5>

        <div class="estimate-input position-relative">
          <h5>Rs.</h5>
          <input
            type="number"
            placeholder="Enter 1 kg price"
            formControlName="perKgRate"
            class="form-control estimate-input"
            min="0"
          />
        </div>

        <h6>= ₹{{ estimateAmount | number : '1.0-0' }}</h6>
      </div>

      <!-- validation for perKgRate -->
      <div class="col-12" *ngIf="controlInvalid(form.get('perKgRate'))">
        <small class="text-danger">
          Please enter a valid per-kg rate (required &gt;= 0.01).
        </small>
      </div>
    </div>

    <div
      class="row g-2 mb-3 mt-2 align-items-center justify-content-between flex-nowrap"
    >
      <div class="col-lg-4">
        <label class="form-label text-body1 d-block">Tempo Charge</label>
        <input
          type="number"
          class="form-control text-body1"
          placeholder="Enter Tempo Charge"
          formControlName="tempoCharge"
          min="0"
        />
      </div>
      <div class="col-lg-4">
        <label class="form-label text-body1 d-block">Hamali</label>
        <input
          type="number"
          class="form-control text-body1"
          placeholder="Enter Hamali"
          formControlName="hamali"
          min="0"
        />
      </div>
      <div class="col-lg-4">
        <label class="form-label text-body1 d-block">Holding Charge</label>
        <input
          type="number"
          class="form-control text-body1"
          placeholder="Enter Holding Charge"
          formControlName="holdingCharge"
          min="0"
        />
      </div>
    </div>

    <hr />

    <!-- FormArray -->
    <div formArrayName="extraCharges">
      <div
        class="row g-2 mb-3 mt-2 align-items-center justify-content-between flex-nowrap"
        *ngFor="
          let chargeCtrl of extraCharges.controls;
          let i = index;
          trackBy: trackByIndex
        "
        [formGroupName]="i"
      >
        <div class="col-lg-4">
          <label class="form-label text-body1 d-block">Charge Name</label>
          <input
            type="text"
            class="form-control text-body1"
            placeholder="Charge Name"
            formControlName="name"
          />
          <div *ngIf="controlInvalid(getExtraControl(i, 'name'))">
            <small class="text-danger">Charge name is required.</small>
          </div>
        </div>

        <div class="col-lg-4">
          <label class="form-label text-body1 d-block">Enter Amount</label>
          <input
            type="number"
            class="form-control text-body1"
            placeholder="Enter Amount"
            formControlName="amount"
            min="0"
          />
          <div *ngIf="controlInvalid(getExtraControl(i, 'amount'))">
            <small class="text-danger"
              >Enter a valid amount (required &ge; 0).</small
            >
          </div>
        </div>

        <div class="col-lg-4 d-flex align-items-center">
          <label class="form-label text-body1 d-block me-2">Action</label>
          <button
            type="button"
            class="delete-btn rounded"
            (click)="removeExtraCharge(i)"
            aria-label="Remove"
          >
            <!-- svg -->
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7 21C6.45 21 5.97917 20.8042 5.5875 20.4125C5.19583 20.0208 5 19.55 5 19V6C4.71667 6 4.47917 5.90417 4.2875 5.7125C4.09583 5.52083 4 5.28333 4 5C4 4.71667 4.09583 4.47917 4.2875 4.2875C4.47917 4.09583 4.71667 4 5 4H9C9 3.71667 9.09583 3.47917 9.2875 3.2875C9.47917 3.09583 9.71667 3 10 3H14C14.2833 3 14.5208 3.09583 14.7125 3.2875C14.9042 3.47917 15 3.71667 15 4H19C19.2833 4 19.5208 4.09583 19.7125 4.2875C19.9042 4.47917 20 4.71667 20 5C20 5.28333 19.9042 5.52083 19.7125 5.7125C19.5208 5.90417 19.2833 6 19 6V19C19 19.55 18.8042 20.0208 18.4125 20.4125C18.0208 20.8042 17.55 21 17 21H7ZM10 17C10.2833 17 10.5208 16.9042 10.7125 16.7125C10.9042 16.5208 11 16.2833 11 16V9C11 8.71667 10.9042 8.47917 10.7125 8.2875C10.5208 8.09583 10.2833 8 10 8C9.71667 8 9.47917 8.09583 9.2875 8.2875C9.09583 8.47917 9 8.71667 9 9V16C9 16.2833 9.09583 16.5208 9.2875 16.7125C9.47917 16.9042 9.71667 17 10 17ZM14 17C14.2833 17 14.5208 16.9042 14.7125 16.7125C14.9042 16.5208 15 16.2833 15 16V9C15 8.71667 14.9042 8.47917 14.7125 8.2875C14.5208 8.09583 14.2833 8 14 8C13.7167 8 13.4792 8.09583 13.2875 8.2875C13.0958 8.47917 13 8.71667 13 9V16C13 16.2833 13.0958 16.5208 13.2875 16.7125C13.4792 16.9042 13.7167 17 14 17Z"
                fill="#F04438"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>

    <button
      type="button"
      class="btn-link btn-link-primary d-flex align-items-center text-body2 gap-1 p-0 mt-2"
      (click)="addExtraCharge()"
    >
      + ADD MORE CHARGE
    </button>
  </div>

  <div class="modal-footer estimate-footer">
    <div class="d-flex align-items-center justify-content-between w-100">
      <div class="left">
        <p>Final Estimated Freight : ₹{{ orderTotal | number : '1.0-0' }}</p>
      </div>
      <button class="btn btn-primary" type="submit">Save</button>
    </div>
  </div>
</form>
